<template>
	<a
		v-if="$data.$_enableCarousel"
		:id="'owl-carousel-' + _uid"
		:href="itemUrl"
		:aria-label="$translate('Ceres::Template.itemImageCarousel')"
		class="owl-carousel owl-theme"
	>
		<div v-for="(imageUrl, index) in imageUrls" :key="index">
			<lazy-img
				v-if="index === 0 && !disableLazyLoad"
				:image-url="imageUrl.url"
				:alt="getAltText(imageUrl)"
				:title="getImageName(imageUrl)"
				:width="getImageWidth(imageUrl)"
                :height="getImageHeight(imageUrl)"
				:second-image="secondImage"
				ref="itemLazyImage"
				picture-class="img-fluid" />
			<img
				v-else-if="index !== 0 && !disableLazyLoad"
				class="img-fluid owl-lazy"
				:data-src="convertFormat(imageUrl.url)"
				:alt="getAltText(imageUrl)"
				:title="getImageName(imageUrl)"
			/>
			<img
				v-else
				class="img-fluid"
				:src="convertFormat(imageUrl.url)"
				:alt="getAltText(imageUrl)"
				:title="getAltText(imageUrl)"
			/>
		</div>
	</a>

	<a
		v-else
		:href="itemUrl"
		:aria-label="getAltText(imageUrls[0])"
	>
		<lazy-img
			v-if="!disableLazyLoad"
			ref="itemLazyImage"
			:image-url="firstImage"
			:fallback-url="firstImage"
			:alt="getAltText(imageUrls[0])"
			:title="getImageName(imageUrls[0])"
			:width="getImageWidth(imageUrls[0])"
            :height="getImageHeight(imageUrls[0])"
			:second-image="secondImage"
			:aria-label="getAltText(imageUrls[0])"
			picture-class="img-fluid"
		></lazy-img>
		<img
			v-else
			class="img-fluid"
			:src="convertFormat(firstImage)"
			:alt="getAltText(imageUrls[0])"
			:title="getImageName(imageUrls[0])"
			:aria-label="getAltText(imageUrls[0])"
			ref="itemImage"
			@mouseover="replaceImage(convertFormat(secondImage.url), 'itemImage')"
			@mouseleave="replaceImage(convertFormat(firstImage), 'itemImage')"
		/>
	</a>
</template>

<script>
import { ImageConverterMixin } from "../../mixins/imageConverter";
import { CategorySecondImageMethods } from "./CategorySecondImageMixin";

export default {
	name: "category-image-carousel",

	mixins: [CategorySecondImageMethods, ImageConverterMixin],

	props: {
		imageUrlsData: {
			type: Array
		},
		itemUrl: {
			type: String
		},
		altText: {
			type: String
		},
		titleText: {
			type: String
		},
		showDots: {
			type: Boolean,
			default: App.config.item.categoryShowDots
		},
		showNav: {
			type: Boolean,
			default: App.config.item.categoryShowNav
		},
		disableLazyLoad: {
			type: Boolean,
			default: false
		},
		disableCarouselOnMobile: {
			type: Boolean
		},
		enableCarousel: {
			type: Boolean
		},
		template: {
			type: String
		}
	},

	data() {
		return {
			$_enableCarousel: false
		};
	},

	computed: {
		imageUrls() {
            return this.imageUrlsData;
		},

		secondImage() {
			return this.imageUrlsData.length > 1 ? this.imageUrlsData[1] : [];
		},

		firstImage() {
            return this.$options.filters.itemImage(this.imageUrls) || "";
		}
	},

	mounted() {
		const isMobile = window.matchMedia("(max-width: 768px)").matches;
		const shouldCarouselBeEnabled = this.enableCarousel && this.imageUrls.length > 1;

		this.$data.$_enableCarousel = this.disableCarouselOnMobile && isMobile ? false : shouldCarouselBeEnabled;
	},

	mounted() {
		this.$nextTick(() => {
			if (this.$data.$_enableCarousel) {
				this.initializeCarousel();
			}
		});
	},

	methods: {
		initializeCarousel() {
			$("#owl-carousel-" + this._uid).owlCarousel({
				dots: !!this.showDots,
				items: 1,
				mouseDrag: false,
				loop: this.imageUrls.length > 1,
				lazyLoad: !this.disableLazyLoad,
				margin: 10,
				nav: !!this.showNav,
				navText: [
					`<i id="owl-nav-text-left-${this._uid}" class='fa fa-chevron-left' aria-hidden='true'></i>`,
					`<i id="owl-nav-text-right-${this._uid}" class='fa fa-chevron-right' aria-hidden='true'></i>`
				],
				onTranslated(event) {
					const element = event.target.querySelector(".owl-item.active img");

					if (element && element.dataset.src && !element.src) {
						element.src = element.dataset.src;
						element.removeAttribute("data-src");
					}
				},
				onInitialized: (event) => {
					if (this.showNav) {
						document.querySelector(`#owl-nav-text-left-${this._uid}`).parentElement.onclick = (event) =>
							event.preventDefault();
						document.querySelector(`#owl-nav-text-right-${this._uid}`).parentElement.onclick = (event) =>
							event.preventDefault();
					}
				}
			});
		},

		getAltText(image) {
			const altText = image && image.alternate ? image.alternate : this.altText;

			return altText;
		},

		getImageName(image) {
			const altText = image && image.name ? image.name : this.titleText;
			
			return altText;
		},

        getImageWidth(image)
        {
            return image && image.width ? image.width : undefined;
        },

        getImageHeight(image)
        {
            return image && image.height ? image.height : undefined;
        }
	}
};
</script>
